import $i from "~/i18n";
import * as actions from "./actions";
import * as mutations from "./mutations";

export default {
    namespaced: true,
    state: () => ({
        hasBio: false,
        bio: {
            fullname: "",
            img: "",
            about: "",
            national_number: "",
            jobPos: "",
            workPlace: "",
            phonenumber: "",
            instagram: "",
            twitter: "",
            facebook: "",
            telegram: "",
            website: "",
            bank_account_number: "",
            credit_card_number: "",
            bank_name: ""
        },
        uploadPercentage: null,
        url: ''
    }),
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/profile/index.js